export const CTD_LIST_REQUEST = "CTD_LIST_REQUEST";
export const CTD_LIST_SUCCESS = "CTD_LIST_SUCCESS";
export const CTD_LIST_FAIL = "CTD_LIST_FAIL";
export const CTD_LIST_RESET = "CTD_LIST_RESET";

export const CTD_DETAILS_REQUEST = "CTD_DETAILS_REQUEST";
export const CTD_DETAILS_SUCCESS = "CTD_DETAILS_SUCCESS";
export const CTD_DETAILS_FAIL = "CTD_DETAILS_FAIL";
export const CTD_DETAILS_RESET = "CTD_DETAILS_RESET";

export const CTD_CREATE_REQUEST = "CTD_CREATE_REQUEST";
export const CTD_CREATE_SUCCESS = "CTD_CREATE_SUCCESS";
export const CTD_CREATE_FAIL = "CTD_CREATE_FAIL";
export const CTD_CREATE_RESET = "CTD_CREATE_RESET";

export const CTD_UPDATE_REQUEST = "CTD_UPDATE_REQUEST";
export const CTD_UPDATE_SUCCESS = "CTD_UPDATE_SUCCESS";
export const CTD_UPDATE_FAIL = "CTD_UPDATE_FAIL";
export const CTD_UPDATE_RESET = "CTD_UPDATE_RESET";

export const CTD_DELETE_REQUEST = "CTD_DELETE_REQUEST";
export const CTD_DELETE_SUCCESS = "CTD_DELETE_SUCCESS";
export const CTD_DELETE_FAIL = "CTD_DELETE_FAIL";
export const CTD_DELETE_RESET = "CTD_DELETE_RESET";
